module.exports = __webpack_public_path__ + "img/BRK-alt.7e9b9e57.svg";